<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

const FilePond = vueFilePond(
    FilePondPluginImagePreview,
);

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import Spinner from "../common/spinner/Spinner.vue";
import {Picker} from 'emoji-mart-vue'
import {emojiPickerGerman} from "../common/emoji-picker/emoji-picker-i18n";
import CharCounter from "../common/char-counter/CharCounter.vue";

export default {
  name: "WhatsappTemplatesForm",
  props: ['record', 'client', 'isAdmin'],
  components: {
    CharCounter,
    Spinner,
    FilePond,
    Picker
  },
  data() {
    return {
      german: emojiPickerGerman,
      showEmojiPicker: false,
      loading: false,
      fileExists: !!this.record?.file,
      header: {
        type: "HEADER",
        format: '',
        text: '',
        example: {
          header_text: [],
          header_handle: '',
        }
      },
      body: {
        type: "BODY",
        text: '',
        example: {
          body_text: [],
        }
      },
      footer: {
        type: 'FOOTER',
        text: 'Um das Abo zu beenden, sende uns die Nachricht "STOP".',
      },
      buttons: {
        type: 'BUTTONS',
        buttons: []
      },
      mode: 'create',
      pond: null,
      name: '',
      file: '',
      interaction: [],
      error: '',
    };
  },
  mounted() {
    if (this.record) {
      this.mode = 'edit';
      this.initData();
    }
  },
  methods: {

    pickEmoji(emoji) {
      this.body.text += emoji.native;
      this.showEmojiPicker = false;
    },

    transformText(type) {
      const textArea = this.$refs.textArea;
      const start = textArea.selectionStart;
      const end = textArea.selectionEnd;
      if (start === end) return; // Kein Text ausgewählt

      const selectedText = this.body.text.substring(start, end);

      let boldText = '';

      switch (type) {
        case 'bold':
          boldText = `*${selectedText}*`;
          break;
        case 'italic':
          boldText = `_${selectedText}_`;
          break;
        case 'strikethrough':
          boldText = `~${selectedText}~`;
          break;
      }

      this.body.text =
          this.body.text.substring(0, start) +
          boldText +
          this.body.text.substring(end);

      this.$nextTick(() => {
        textArea.setSelectionRange(start + boldText.length, start + boldText.length);
        textArea.focus();
      });
    },

    addQuickReplies() {

      // filter buttons with type QUICK_REPLY
      const quickReplies = this.buttons.buttons.filter(button => button.type === 'QUICK_REPLY');

      if (quickReplies.length < 2) {
        this.buttons.buttons.push({
          type: 'QUICK_REPLY',
          text: '',
        });
      }
    },

    addCtaPhoneButton() {

      // check if there is already a phone number button
      if (this.buttons.buttons.some(button => button.type === 'PHONE_NUMBER')) {
        return;
      }

      this.buttons.buttons.push({
        type: 'PHONE_NUMBER',
        text: '',
        phone_number: '',
        countryCode: '+49'
      });
    },
    addCtaWebsiteButton() {

      // check if there is already a website button
      if (this.buttons.buttons.some(button => button.type === 'URL')) {
        return;
      }

      this.buttons.buttons.push({
        type: 'URL',
        text: '',
        url: ''
      });
    },
    detectPlaceholder(type) {

      const text = this[type].text;
      const regex = /{{(.*?)}}/g;
      const matches = text.match(regex);

      if (matches) {
        matches.forEach(match => {

          match = match.replace(/{{|}}/g, '');

          // if match is not in header.example.header_text add it
          if (!this[type].example[type + '_text'].some(item => Object.keys(item)[0] === match)) {
            this[type].example[type + '_text'].push({[match]: ''});
          }

          // remove all items from header.example.header_text that are not in text
          this[type].example[type + '_text'] = this[type].example[type + '_text'].filter(item => {
            return text.includes(`{{${Object.keys(item)[0]}}}`);
          });
        });
      } else {
        this[type].example[type + '_text'] = [];
      }
    },

    addPlaceholderToHeader(type, ref) {
      const text = this[type].text;
      const regex = /{{(.*?)}}/g;
      const matches = text.match(regex);
      const textArea = this.$refs[ref];

      // Ermitteln der aktuellen Cursorposition
      const cursorPosition = textArea.selectionStart;

      let placeholderText;
      if (matches) {
        placeholderText = '{{' + (matches.length + 1) + '}}';
      } else {
        placeholderText = '{{1}}';
      }

      this[type].text =
          text.substring(0, cursorPosition) +
          placeholderText +
          text.substring(cursorPosition);

      this.detectPlaceholder(type);
    },

    removePlaceholder(type, placeholder) {
      // search for placeholder in text and remove it
      this[type].text = this[type].text.replace(`{{${placeholder}}}`, '');

      // remove placeholder from example
      this[type].example[type + '_text'] = this[type].example[type + '_text'].filter(item => {
        return Object.keys(item)[0] !== placeholder;
      });
    },

    initData() {
      this.name = this.record.name;
      this.header = JSON.parse(this.record.header);
      this.body = JSON.parse(this.record.body);
      this.footer = JSON.parse(this.record.footer);
      this.buttons = JSON.parse(this.record.buttons);
      this.interaction = this.record.interaction;
      this.buttons.buttons = this.buttons.buttons.map(button => {
        if (button.type === 'PHONE_NUMBER') {
          const match = button.phone_number.match(/^(0049|0043|0041)(.*)$/);
          if (match) {
            button.countryCode = match[1].replace('00', '+');
            button.phone_number = match[2];
          } else {
            button.countryCode = '+49';
          }
        }
        return button;
      });

      if (this.record.file) {
        setTimeout(() => {
          this.pond.addFile(this.record.file);
        }, 500);
      }
    },
    removeCtaButton(index) {
      if (this.buttons.buttons.length > 0) {
        this.buttons.buttons.splice(index, 1);
      }
    },
    removeQuickReply(index) {
      if (this.buttons.buttons.length > 0) {
        this.buttons.buttons.splice(index, 1);
      }
    },
    acceptedFiles() {
      switch (this.header.format) {
        case 'IMAGE':
          return 'image/jpeg, image/png, image/jpg';
        case 'VIDEO':
          return 'video/mov, video/mp4, video/QuickTime';
        case 'DOCUMENT':
          return 'application/pdf';
        default:
          return '';
      }
    },
    handleFilePondInit() {
      this.pond = this.$refs.pond;
    },
    async saveTemplate(action) {

      this.error = '';

      if (action === 'approve' && !confirm('Möchten Sie die Vorlage zur Genehmigung einreichen?')) {
        return;
      }

      this.loading = true;

      const files = this.pond.getFiles();
      const formData = new FormData();

      if (!this.fileExists) {
        files.forEach(fileItem => {
          formData.append('file', fileItem.file);
        });
      }

      formData.append('name', this.name);
      formData.append('client_id', this.client?.id);
      formData.append('header', JSON.stringify(this.header));
      formData.append('body', JSON.stringify(this.body));
      formData.append('footer', JSON.stringify(this.footer));

      const buttonsWithFormattedNumbers = JSON.parse(JSON.stringify(this.buttons));

      buttonsWithFormattedNumbers.buttons = buttonsWithFormattedNumbers.buttons.map(button => {
        if (button.type === 'PHONE_NUMBER') {
          const number = button.phone_number.trim().replace(/^0+/, '');
          const countryCode = button.countryCode.replace('+', '00');
          button.phone_number = countryCode + number;
        }
        return button;
      });

      formData.append('buttons', JSON.stringify(buttonsWithFormattedNumbers));
      formData.append('interaction', this.interaction);
      formData.append('action', action);


      let url = '/backend/whatsapp_templates';

      if (this.mode === 'edit') {
        url = `/backend/whatsapp_templates/${this.record.id}`;
      }

      await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        this.error = '';
        window.location.href = this.isAdmin
            ? `/backend/whatsapp_templates?client_id=${this.client?.id}`
            : '/backend/whatsapp_templates';
      }).catch(error => {
        this.loading = false;
        this.error = [['Ein Fehler ist aufgetreten']];

        if (error.response.data.errors) {
          this.error = error.response.data.errors;
        }
      });
    },
    changeHeaderFormat() {
      this.header.text = '';
      this.header.example.header_text = [];
      this.pond.removeFiles()
    },
    formatNameString() {
      // replace whitespaces with underscores
      this.name = this.name.replace(/\s/g, '_');

      // replace umlauts
      this.name = this.name.replace(/ä/g, 'ae');
      this.name = this.name.replace(/ö/g, 'oe');
      this.name = this.name.replace(/ü/g, 'ue');
      this.name = this.name.replace(/ß/g, 'ss');

      // convert to lowercase
      this.name = this.name.toLowerCase();
    }
  }
}
</script>

<template>
  <div class="">

    <div class="alert alert-danger" v-if="error">
      <ul>
        <li v-for="errorMsg in error">{{ errorMsg[0] }}</li>
      </ul>
    </div>

    <spinner v-if="loading"></spinner>
    <div>
      <div class="panel panel-default" v-if="isAdmin">
        <div class="panel-heading">
          <span style="font-weight: 700" class="text-uppercase">Mandant</span>
        </div>
        <div class="panel-body">
          <div class="form-group">
            <input type="text" class="form-control" :value="client && client.name" disabled>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading">
          <span style="font-weight: 700" class="text-uppercase">WhatsApp Vorlage</span>
          <a class="fa fa-question-circle" v-tippy
             content="
             Um WhatsApp Newsletter zu versenden, müssen Vorlagen erstellt und von Meta genehmigt werden.
             Die Vorlage muss einen Namen und Inhaltstext beinhalten, um zur Genehmigung eingereicht werden zu können. Die Genehmigung von Meta kann bis zu 24 h dauern."></a>
        </div>
        <div class="panel-body">

          <div class="form-group">
            <label for="">Name der Vorlage *</label>
            <a class="fa fa-question-circle" v-tippy
               content="Der Titel der Vorlage darf nur Kleinbuchstaben und Unterstriche als Leerzeichen enthalten (keine Umlaute, Zahlen, Satz- und Sonderzeichen).
Beispiel: whatsapp_vorlage_fashionshow"></a>
            <input type="text" v-model="name" class="form-control" @input="formatNameString" required>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading">
          <span style="font-weight: 700" class="text-uppercase">Header (optional)</span>
          <a class="fa fa-question-circle" v-tippy
             content="Als Header kann ein Bild, Video oder Dokument eingestellt werden. Im Newsletter kann nur der gleiche Header-Typ (z.B. Bild) verwendet werden, wie in der Vorlage ausgewählt wurde."></a>
        </div>
        <div class="panel-body">
          <div class="form-group">
            <label for="">Header-Typ</label>
            <select class="form-control" v-model="header.format" @change="changeHeaderFormat">
              <option value="">Bitte auswählen</option>
              <option value="TEXT">Text</option>
              <option value="IMAGE">Bild</option>
              <option value="VIDEO">Video</option>
              <option value="DOCUMENT">Dokument</option>
            </select>
          </div>

          <div :class="{hidden: header.format === '' || header.format === 'TEXT'}"
               style="padding: 20px; background: #F7F7F7">

            <div>
              <h3>Beispiele für Kopfzeileninhalte</h3>
              Damit deine Inhalte leichter überprüft werden können, gib bitte in der Kopfzeile Beispiele für die
              Medien an. Gib keine Kundeninformationen an.
            </div>

            <br>

            <div class="alert alert-info" style="max-width: 900px" v-if="['IMAGE', 'VIDEO'].includes(header.format)">
              <i class="fa fa-info-circle"></i>
              Wir empfehlen quadratische Formate der Bild- oder Videodateien, da diese ideal in der Vorschau der
              WhatsApp-Nachricht angezeigt werden.
            </div>

            <label for="">Beispieldatei</label>
            <div class="whatsapp-file">
              <file-pond
                  name="image"
                  ref="pond"
                  label-idle="Hier klicken oder Datei reinziehen..."
                  :allow-multiple="false"
                  :accepted-file-types="acceptedFiles()"
                  maxFileSize="10MB"
                  :instant-upload="false"
                  @init="handleFilePondInit"
                  @removefile="() => fileExists = false"
                  :allow-revert="false"
                  :allow-process="false"
              />
            </div>
          </div>

          <div class="form-group" v-if="header.format === 'TEXT'">

            <label for="">Header-Text</label>
            <textarea @change="detectPlaceholder('header')" @input="detectPlaceholder('header')" ref="textarea_header"
                      class="form-control"
                      v-model="header.text"></textarea>
            <button class="btn btn-sm" style="margin-top: 10px;"
                    @click="addPlaceholderToHeader('header', 'textarea_header')">
              <i class="fa fa-plus"></i>
              Platzhalter hinzufügen
            </button>
          </div>

          <div class="form-group" style="padding: 20px; background: #F7F7F7"
               v-if="header.example.header_text.length > 0 && header.format === 'TEXT'">
            <div>
              <h3>Beispiele für Kopfzeileninhalte</h3>
              Damit deine Inhalte leichter überprüft werden können, gib bitte in der Kopfzeile Beispiele für die
              Variablen an. Gib keine Kundeninformationen an.
            </div>
            <br>
            <div class="row">
              <div v-for="(item, index) in header.example.header_text" class="col-md-3">
                <label :for="'header_example_' + index">Beispieltext für {{ Object.keys(item)[0] }}:</label>
                <a class="fa fa-trash text-danger" @click="removePlaceholder('header', Object.keys(item)[0] )"></a>
                <input type="text" class="form-control" :id="'header_example_' + index"
                       :placeholder="`Inhalt für ${Object.keys(item)[0]} eingeben`"
                       v-model="item[Object.keys(item)[0]]">
              </div>
            </div>

          </div>
        </div>

      </div>

      <div class="panel panel-default">
        <div class="panel-heading">
          <span style="font-weight: 700" class="text-uppercase">Inhalt</span>
          <a class="fa fa-question-circle" v-tippy
             :content="`Mit Platzhaltern können Textbausteine (z.B. Anrede, Rabatt-Aussagen, etc.) in Newslettern individualisiert werden. Die Platzhalter werden im Textfeld mit {{1}}, {{2}} usw. dargestellt.`"></a>
        </div>
        <div class="panel-body">
          <div class="form-group" style="position:relative;">
            <label>Haupttext *</label>
            <div class="alert alert-info">
              <i class="fa fa-info-circle"></i>
              Bitte beachten: Der Haupttext sollte mindestens aus 2 Sätzen bestehen und nicht zu viele Platzhalter
              enthalten (das Verhältnis zwischen der Anzahl der Platzhalter und der Länge des Textes sollte ausgewogen
              sein). Ansonsten steigt die Wahrscheinlichkeit, dass Meta die Vorlage ablehnt.
            </div>
            <div>
              <button
                  class="textarea-button"
                  @click="transformText('bold')"
                  style="font-weight: bold">
                B
              </button>
              <button
                  @click="transformText('italic')"
                  class="textarea-button"
                  style="font-style: italic">
                I
              </button>
              <button
                  @click="transformText('strikethrough')"
                  class="textarea-button"
                  style="text-decoration: line-through">
                S
              </button>
              <button
                  class="textarea-button"
                  style="font-size: 10px"
                  @click="showEmojiPicker = !showEmojiPicker"
              >
                😊
              </button>
              <picker :i18n="german" v-if="showEmojiPicker" @select="pickEmoji" :native="true" :showPreview="false"
                      color="#304050"
                      :style="{ position: 'absolute', zIndex: 9999}"/>
            </div>
            <textarea
                ref="textArea"
                v-model="body.text"
                @input="detectPlaceholder('body')"
                @change="detectPlaceholder('body')"
                rows="10"
                class="form-control"></textarea>
            <button class="btn btn-sm" style="margin-top: 10px" @click="addPlaceholderToHeader('body', 'textArea')">
              <i class="fa fa-plus"></i>
              Platzhalter hinzufügen
            </button>
          </div>

          <div class="form-group" v-if="body.example.body_text.length > 0" style="padding: 20px; background: #F7F7F7">
            <div>
              <h3>Beispiele für Textinhalte</h3>
              Bitte gib ein Beispiel für jede Variable in deinem Text an, damit deine Nachrichtenvorlage überprüft
              werden kann. Verwende dafür bitte keine echten Kundeninformationen.
            </div>
            <br>
            <div class="row">
              <div v-for="(item, index) in body.example.body_text" class="col-md-3">
                <label :for="'body_example_' + index">Beispieltext für {{ Object.keys(item)[0] }}:</label>
                <a class="fa fa-trash text-danger" @click="removePlaceholder('body', Object.keys(item)[0] )"></a>
                <input type="text" class="form-control" :id="'body_example_' + index"
                       :placeholder="`Inhalt für ${Object.keys(item)[0]} eingeben`"
                       v-model="item[Object.keys(item)[0]]">
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading">
          <span style="font-weight: 700" class="text-uppercase">Footer</span>
          <a class="fa fa-question-circle" v-tippy
             content='Fügen Sie bei jedem Newsletter einen Footer-Text hinzu, der darauf hinweist, dass das Abo jederzeit mit der Nachricht “Stop” beendet werden kann. Der vorgegebene Footer-Text kann angepasst werden.'></a>
        </div>
        <div class="panel-body">
          <div class="form-group">
            <label for="">Footer-Text</label>
            <a class="fa fa-question-circle" v-tippy
               content="Der Footer Text darf nicht mehr als 60 Zeichen beinhalten."></a>
            <input maxlength="60" type="text" v-model="footer.text" class="form-control" required>
            <char-counter limit="60" :text="footer.text"></char-counter>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading">
          <span style="font-weight: 700" class="text-uppercase">Buttons (optional)</span>
          <a class="fa fa-question-circle" v-tippy
             content="Als Interaktionsmöglichkeit können Call-to-Action-Buttons und Schnellantworten hinterlegt werden. Beim CTA-Button kann eine Telefonnummer oder ein Link angegeben werden. Der Inhalt der Schnellantwort wird im Newsletter eingegeben, in der Vorlage nur das Button-Label."></a>
        </div>
        <div class="panel-body">
          <div>
            <label for="">Interaktion</label>
            <Select2 v-model="interaction"
                     :settings="{multiple: true}"
                     :options="[{id: 'cta', text: 'Call-to-Action'}, {id: 'quick_reply', text: 'Schnellantwort'}]"/>
          </div>

          <div style="display: flex; padding-top: 10px;">
            <div v-if="interaction.includes('cta')">
              <button class="btn btn-secondary" @click="addCtaPhoneButton"
                      v-if="buttons.buttons && !buttons.buttons.some(item => item.type === 'PHONE_NUMBER')">
                <i class="fa fa-plus"></i>
                Telefonnummer hinzufügen
              </button>
              <button class="btn btn-secondary" @click="addCtaWebsiteButton"
                      v-if="buttons.buttons && !buttons.buttons.some(item => item.type === 'URL')">
                <i class="fa fa-plus"></i>
                URL hinzufügen
              </button>
            </div>
            <div v-if="interaction.includes('quick_reply')">
              <button class="btn btn-secondary" style="margin-left: 5px" @click="addQuickReplies"
                      v-if="this.buttons.buttons.filter(button => button.type === 'QUICK_REPLY').length < 2">
                <i class="fa fa-plus"></i>
                Schnellantwort hinzufügen
              </button>
            </div>
          </div>

          <div style="margin: 10px 0" id="cta"
               v-if="interaction.includes('cta') || interaction.includes('quick_reply')">

            <div class="row" style="padding-top: 10px;">
              <div v-for="(button, index) in buttons.buttons" class="col-md-6"
                   v-if="interaction.includes('cta') && (button.type === 'PHONE_NUMBER' || button.type === 'URL')">

                <div v-if="button.type === 'PHONE_NUMBER'">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <strong>
                        Telefonnummer
                        <i class="fa fa-trash text-danger" style="cursor: pointer"
                           @click="removeCtaButton(index)"></i>
                      </strong>
                    </div>
                    <div class="panel-body">
                      <label for="">Telefonnummer</label>
                      <div style="display: flex; align-items: center;">
                        <select v-model="button.countryCode" class="form-control" style="width: 90px; margin-right: 10px;">
                          <option value="+49" selected>🇩🇪 DE</option>
                          <option value="+43">🇦🇹 AT</option>
                          <option value="+41">🇨🇭 CH</option>
                        </select>
                        <div style="position: relative; flex-grow: 1;">
                          <input type="text"
                                 v-model="button.phone_number"
                                 class="form-control"
                                 style="padding-left: 50px;">
                          <span style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); pointer-events: none; color: #888;">
                            {{ button.countryCode || '+49' }} |
                          </span>
                        </div>
                      </div>

                      <label for="">Button-Label</label>
                      <a class="fa fa-question-circle" v-tippy
                         content="Texte in Buttons dürfen nicht mehr als 20 Zeichen beinhalten."></a>
                      <input maxlength="20" type="text" v-model="button.text" class="form-control">
                      <char-counter limit="20" :text="button.text"></char-counter>
                    </div>
                  </div>
                </div>

                <div v-if="button.type === 'URL'">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <strong>
                        URL
                        <i class="fa fa-trash text-danger" style="cursor: pointer"
                           @click="removeCtaButton(index)"></i>
                      </strong>
                    </div>
                    <div class="panel-body">
                      <label for="">URL</label>
                      <input type="text" v-model="button.url" class="form-control">

                      <label for="">Button-Label</label>
                      <a class="fa fa-question-circle" v-tippy
                         content="Texte in Buttons dürfen nicht mehr als 20 Zeichen beinhalten."></a>
                      <input maxlength="20" type="text" v-model="button.text" class="form-control">
                      <char-counter limit="20" :text="button.text"></char-counter>
                    </div>
                  </div>
                </div>
              </div>
              <div v-for="(button, index) in buttons.buttons" class="col-md-6"
                   v-if="interaction.includes('quick_reply') && button.type === 'QUICK_REPLY'">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <strong>
                      Schnellantwort
                      <i class="fa fa-trash text-danger" style="cursor: pointer" @click="removeQuickReply(index)"></i>
                    </strong>
                  </div>
                  <div class="panel-body">
                    <label for="">Button-Label</label>
                    <a class="fa fa-question-circle" v-tippy
                       content="Texte in Buttons dürfen nicht mehr als 20 Zeichen beinhalten."></a>
                    <input type="text" maxlength="20" v-model="button.text" class="form-control">
                    <char-counter limit="20" :text="button.text"></char-counter>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" v-if="error">
      <ul>
        <li v-for="errorMsg in error">{{ errorMsg[0] }}</li>
      </ul>
    </div>

    <div v-if="!loading">
      <div v-if="!record || ['DRAFT', 'REJECTED', 'APPROVED', 'PAUSED'].includes(record.status)">
        <button class="btn btn-primary" style="margin-bottom: 40px" @click="saveTemplate('approve')">Zur Genehmigung
          einreichen
        </button>
        <button class="btn btn-default" style="margin-bottom: 40px" @click="saveTemplate('draft')">Speichern</button>
        <a :href="isAdmin ? `/backend/whatsapp_templates?client_id=${client && client.id}` : '/backend/whatsapp_templates'" class="btn btn-default" style="margin-bottom: 40px">Abbrechen</a>
      </div>
    </div>
  </div>

</template>

<style scoped>
.textarea-button {
  font-family: 'monospace', Serif;
  border: 1px solid gray;
  width: 25px;
  height: 25px;
  text-align: center;
  margin: 10px 0;
}

.filepond--root {
  font-size: 1.5rem;
}
</style>
